// src/components/HeroSlider.jsx
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";

import "swiper/css";
import "swiper/css/effect-fade";
import "./heroSlider.css";

const heroImages = [
  { src: "files/DSC06908.jpg", text: "Crafting Premium Linen Fabrics" },
  { src: "files/DSC06970.jpg", text: "Precision in Every Thread" },
  { src: "files/DSC06539.jpg", text: "Advanced Weaving Excellence" },
  { src: "files/DSC06915.JPG", text: "Where Craft Meets Innovation" }
];

const HeroSlider = () => {
  return (
    <div className="hero-slider-container">
      <Swiper
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        speed={1000}
        className="hero-swiper"
      >
        {heroImages.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="hero-slide"
              style={{ backgroundImage: `url(${img.src})` }}
            >
              <div className="hero-overlay"></div>

              <div className="hero-text">
                <h1>{img.text}</h1>
                <p>Manufacturers of Superior Linen & Quality Fabrics</p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSlider;
